import React from 'react';
import axios from "../../../containers/api";
import "../components/ManageUsers.css";
import {Colxx, Separator} from "../../../components/common/CustomBootstrap";
import { Badge, Button, Card, CardBody, Modal, ModalBody, ModalFooter, ModalHeader, Row, FormGroup, Label } from "reactstrap";
import {showCatchError} from "../../../helpers/Utils";
import {Table} from "../../../components/table/Table";
import EditUser from "../components/EditUser";
import ChangePassModal from "../../user/components/ChangePassModal";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import AddAdminUser from "../admin-add-user/AddAdminUser";
import ShowTransportationCompanyUser from "./components/ShowTransportationCompanyUser";
import ShowLoadHallUser from "./components/ShowLoadHallUser";
class AdminUser extends React.Component {
    state = {
       
        UserByAdmins: [],
        AllUsers: [],
        UserByAdmin: null,
        OneUser: null,
        AddUserModal:false,
        ShowButton: false,
        ChangePassModal: false,
        showTransportationCompanyUserModal: false,
        showLoadHallUserModal: false,
        TransportationCompanies: [],
        LoadHalls: [],
        OneTransportationCompany:null,
        OneLoadHall:null
    };

    componentDidMount() {
        this.UserByAdmin();
        this.GetAdminUserByType(this.state.UserByAdmin);
    }

    GetAdminUserByType = (Type) => {
        if (Type !== null && Type !== undefined) {  
        this.props.showSpinner();
            axios.get('/api/v1/User/GetAdminUserByType?Type=' + Type.type)
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ AllUsers: res.data.data });
                //console.log(res.data.data)
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    }
        else {
            this.setState({
                AllUsers: [],
            })
        }
    };
    openModal = (modalName, item) => {
        if (modalName === "showTransportationCompanyUserModal") {
            if (this.state.TransportationCompanies.length === 0) {
                this.getTransportationCompanies();
            }
            this.setState({
                [modalName]: true,
                OneTransportationCompany: item
            });
        }
        if (modalName === "showLoadHallUserModal") {
            if (this.state.LoadHalls.length === 0) {
                this.getLoadHalls();
            }
            this.setState({
                [modalName]: true,
                OneLoadHall: item
            });
        }
        else  if (modalName === "ChangePassModal") {
            this.setState({
                [modalName]: true,
                UserName: item.userName

            });
        }
        else {
            this.setState({
                [modalName]: true
            });
        }
    }
    closeModal = (modalName) => {
        this.setState({ [modalName]: false });
        this.GetAdminUserByType(this.state.UserByAdmin);
    };
    UserByAdmin = () => {
        this.props.showSpinner();
        axios.get('/api/v1/UserByAdmin/GetAll')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ UserByAdmins: res.data.data });
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    selectHandleChange = (event, value, name) => {
        if (name === "UserByAdmin") {
            this.setState({ [name]: value, ShowButton:true });
            if (value !== undefined && value !== null) {
                this.GetAdminUserByType(value);
            }
            else {
                this.setState({
                    AllUsers: [],
                    ShowButton: false
                })
            }

        }
        else {
            this.setState({
                [name]: null,
                ShowButton: false
            });
        }
        
       
    };
    getTransportationCompanies = () => {
        this.props.showSpinner();
        axios.get('/api/v1/TransportationCompany/GetAll')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ TransportationCompanies: res.data.data });
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    getLoadHalls = () => {
        this.props.showSpinner();
        axios.get('/api/v1/LoadHall/GetAll')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ LoadHalls: res.data.data });
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    render() {
        return (
            <>
                <Row>
                    <Colxx xxs="12">
                        <h3> کاربران</h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>
                <div className="d-flex flex-md-row flex-column w-100 justify-content-center flex-wrap">
                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>كاربر:</Label>
                        <Autocomplete
                            clearText={"حذف"}
                            closeText={"بستن"}
                            noOptionsText={"در حال دریافت اطلاعات.."}
                            openText={"باز کردن"}
                            className="react-select__control"
                            id="kala"
                            options={this.state.UserByAdmins}
                            getOptionLabel={(option) => option.name}
                            value={this.state.UserByAdmin}
                            onChange={(e, v) => this.selectHandleChange(e, v, "UserByAdmin")}
                            renderInput={(params) => (<TextField{...params} variant="standard" />)}
                        />
                    </FormGroup>
                    {this.state.ShowButton && 
                    <FormGroup className="w-md-30 w-100 px-1">
                        <Button outline color="secondary" className="mx-3 my-md-0 my-1"
                            onClick={() => this.setState({ AddUserModal:true})}>
                            كاربر جديد {this.state.UserByAdmin && this.state.UserByAdmin.name}
                        </Button>
                        </FormGroup>
                    }
                  
                    </div>
                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column justify-content-center align-items-center">
                                <Table
                                    tableHeaders={[
                                        "نام کاربری",
                                        "نام و نام خانوادگی", 
                                        "وضعیت",
                                    /*    "ویرایش",*/
                                        "نمایندگی‌ها", 
                                        "سالن‌ها", 
                                        "تغییر رمز",
                                    ]}

                                    tableRow={this.state.AllUsers}

                                    tableData={[
                                        a => {
                                            return a.userName;
                                        },
                                        a => {
                                            return a.fullName;
                                        },
                                        
                                        a => {
                                            return (
                                                a.isActive === false ?
                                                    <Badge color="outline-danger" pill>غیر فعال</Badge>
                                                    :
                                                    <Badge color="outline-success" pill>فعال</Badge>
                                                )
                                        },
                                        //a => {
                                        //    return (
                                        //        <Button outline color="info" className="btn-sm" onClick={() => this.setState({ OneUser: a, EditUserModal: true})}>
                                        //            ویرایش
                                        //        </Button>
                                        //    )
                                        //},
                                        a => {
                                            return (
                                                <Button outline color="primary" size="sm"
                                                    onClick={() => this.openModal("showTransportationCompanyUserModal", a)}>
                                                    شرکت های حمل و نقل
                                                </Button>
                                            )
                                        },
                                        a => {
                                            return (
                                                <Button outline color="primary" size="sm"
                                                    onClick={() => this.openModal("showLoadHallUserModal", a)}>
                                                    سالن ها
                                                </Button>
                                            )
                                        },
                                        a => {
                                            return (
                                              
                                                  <Button outline color="primary" size="sm"
                                                        onClick={() => this.openModal("ChangePassModal",   a)}>
                                                    تغییر رمز
                                                </Button>
                                            )
                                        }
                                    ]}
                                />
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                <Modal isOpen={this.state.EditUserModal} size="xlg" toggle={() => this.setState({EditUserModal: false})}>
                    <ModalHeader toggle={() => this.closeModal("EditUserModal")}>
                        ویرایش کاربر
                    </ModalHeader>
                    <ModalBody>
                        <EditUser
                            Page={"Support"}
                            agency={this.state.OneUser}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.setState({EditUserModal: false})}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.ChangePassModal} size="xlg" toggle={() => this.closeModal("ChangePassModal")}>
                    <ModalHeader toggle={() => this.closeModal("ChangePassModal")}>
                        تغییر رمز کاربری
                    </ModalHeader>
                    <ModalBody>
                        <ChangePassModal
                            UserName={this.state.UserName}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.closeModal("ChangePassModal")}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>
                 
                <Modal isOpen={this.state.AddUserModal} size="xlg" toggle={() => this.setState({ AddUserModal: false })}>
                    <ModalHeader toggle={() => this.closeModal("AddUserModal")}>
                        كاربر جديد {this.state.UserByAdmin && this.state.UserByAdmin.name }
                    </ModalHeader>
                    <ModalBody>
                        <AddAdminUser
                            Page={"Support"}
                            Type={this.state.UserByAdmin}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.setState({ AddUserModal: false })}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.showTransportationCompanyUserModal} size="xlg" toggle={() => this.setState({ showTransportationCompanyUserModal: false })}>
                    <ModalHeader toggle={() => this.setState({ showTransportationCompanyUserModal: false })}>
                        نمایندگی‌ها
                    </ModalHeader>
                    <ModalBody>
                        <ShowTransportationCompanyUser
                            OneTransportationCompany={this.state.OneTransportationCompany}
                            TransportationCompanies={this.state.TransportationCompanies}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.setState({ showTransportationCompanyUserModal: false })}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.showLoadHallUserModal} size="xlg" toggle={() => this.setState({ showLoadHallUserModal: false })}>
                    <ModalHeader toggle={() => this.setState({ showLoadHallUserModal: false })}>
                        نمایندگی‌ها
                    </ModalHeader>
                    <ModalBody>
                        <ShowLoadHallUser
                            OneLoadHall={this.state.OneLoadHall}
                            LoadHalls={this.state.LoadHalls}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.setState({ showLoadHallUserModal: false })}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>


            </>
        )

    }
}

export default AdminUser;